export default "__VITE_ASSET__f760a027__"